export const BASE_YEAR = 1920;
export const COLUMNS_SMALL_SCREEN = 3;
export const COLUMNS_LARGE_SCREEN = 4;
